/**
 * Object Type Store - Persistence helpers (localStorage)
 */

import { storage } from '../../lib/utils';
import { applyStrokeOnlyDefaults } from './strokeOnlyDefaults';
import type { ObjectType, Mapping, LayerTypeMapping, ObjectTypeState } from './types';

export const getStorageKey = (lotId: string | null): string => {
  return lotId ? `map-editor-object-types-${lotId}` : 'map-editor-object-types-global';
};

// Load initial state from localStorage for a specific lot
export const loadInitialState = (
  lotId: string | null
): Pick<ObjectTypeState, 'types' | 'mappings' | 'layerTypeMappings'> => {
  const stored = storage.get<{ types: ObjectType[]; mappings: Mapping[]; layerTypeMappings: LayerTypeMapping[] }>(
    getStorageKey(lotId),
    { types: [], mappings: [], layerTypeMappings: [] }
  );
  // stroke-only 타입(조명 프레임/존/외곽선)은 localStorage 복원 시에도 채우기 없음 + 10px 고정.
  return {
    ...stored,
    types: (stored.types ?? []).map(applyStrokeOnlyDefaults),
  };
};
